<template>
    <v-btn @click="$emit('click')" depressed tile outlined v-bind="$attrs">{{ content }}<slot /></v-btn>
</template>

<script>
export default {
    props: ["content"],
};
</script>

<style></style>
